import React, { ReactNode } from "react";
import { UseFormRegister, FieldErrors, RegisterOptions } from "react-hook-form";

// Props interface for the FormCheckbox component
interface FormCheckboxProps {
  label: string | ReactNode;
  name: string;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  options?: RegisterOptions;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  label,
  name,
  register,
  errors,
  options = {},
}) => {
  return (
    <div>
      <div className="flex items-start">
        <input
          type="checkbox"
          id={name}
          {...register(name, options)}
          className="mt-1"
        />
        <label htmlFor={name} className="ms-2 text-sm text-gray-600">
          {label}
        </label>
      </div>
      {errors[name] && (
        <p className="text-red-500 text-xs mt-1">
          {errors[name]?.message?.toString()}
        </p>
      )}
    </div>
  );
};

export default FormCheckbox;
